import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, GlobeIcon } from 'lucide-react';
export function TrustMetrics() {
  const metrics = [{
    icon: UsersIcon,
    value: '+2.400 profesionales',
    label: 'ya lo tienen'
  }, {
    icon: BookOpenIcon,
    value: '6 Tomos + 6 Bonos',
    label: 'material completo'
  }, {
    icon: StarIcon,
    value: '⭐ 4.9/5',
    label: 'valoración'
  }, {
    icon: GlobeIcon,
    value: 'Todo el país',
    label: 'envío digital'
  }];
  return <section className="w-full bg-[#0A0A0A] py-4" data-id="element-274">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-275">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-276">
          {metrics.map((metric, index) => <div key={index} className="text-center" data-id="element-277">
              <div className="flex justify-center mb-1" data-id="element-278">
                <metric.icon className="w-5 h-5 text-[#D4A843]" data-id="element-279" />
              </div>
              <div className="text-lg font-bold text-white mb-0.5" data-id="element-280">
                {metric.value}
              </div>
              <div className="text-xs text-[#D4A843]" data-id="element-281">{metric.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}